<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/info' }">账户设置</el-breadcrumb-item>
            <el-breadcrumb-item><span v-if="!$route.query.id">创建</span><span v-else>编辑</span>服务需求项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div style="padding-top: 20px; margin: 0 20px -5px;" v-if="formItem.status === 4">
                <el-alert
                    :title="'失败原因：'+formItem.verify_remark"
                    :center="true"
                    type="error"
                    :closable="false"
                    >
                </el-alert>
            </div>
            <div style="padding-top: 20px; margin: 0 20px -5px;" v-if="formItem.status === 2">
                <el-alert
                    :title="'失败原因：'+formItem.review_remark"
                    :center="true"
                    type="error"
                    :closable="false"
                >
                </el-alert>
            </div>
            <div class="form-title text-center">
                <span v-if="!$route.query.id">创建</span><span v-else>编辑</span>服务需求项目
            </div>
            <div class="form-content">
                <el-form label-width="100px">
                    <el-form-item label="类别">
                        <el-select v-model="formItem.category_id" placeholder="请选择">
                            <el-option
                                v-for="(item, key) in categories"
                                :key="key"
                                :label="item.name"
                                :value="item.category_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服务内容">
                        <el-input v-model="formItem.name" placeholder="请输入服务内容"></el-input>
                    </el-form-item>
                    <el-form-item label="单位">
                        <el-input v-model="formItem.unit" placeholder="请输入单位"></el-input>
                    </el-form-item>
                    <el-form-item label="服务要求">
                        <el-input type="textarea" :rows="2" style="font-size: 12px;" placeholder="请输入服务要求" v-model="formItem.demand"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" v-if="!$route.query.id" @click="submitForm">添加</el-button>
                        <el-button type="primary" v-else @click="edit">重新提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'AddService',
    data () {
        return {
            categories: [],
            formItem: {
                demand: '',
                unit: '',
                category_id: '',
                name: ''
            }
        }
    },
    mounted () {
        this.getCategories()
        let tId = this.$route.query.id
        if (tId) {
            this.getInfo(tId)
        } else {
            this.formItem = {
                demand: '',
                unit: '',
                category_id: '',
                name: ''
            }
        }
    },
    methods: {
        submitForm () {
            if (this.formItem.name === '') {
                this.$message.error('请输入服务内容')
            } else if (this.formItem.category_id === '') {
                this.$message.error('请选择服务类别')
            } else if (this.formItem.unit === '') {
                this.$message.error('请输入单位')
            } else {
                this.$http.post('/api/user/service/create', qs.stringify({
                    demand: this.formItem.demand,
                    unit: this.formItem.unit,
                    category_id: this.formItem.category_id,
                    name: this.formItem.name
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '创建成功'
                            })
                            router.go(-1)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        },
        getInfo (id) {
            this.$http.get('/api/user/service/info', {
                params: {
                    id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.formItem = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        edit () {
            if (this.formItem.name === '') {
                this.$message.error('请输入服务内容')
            } else if (this.formItem.category_id === '') {
                this.$message.error('请选择服务类别')
            } else if (this.formItem.unit === '') {
                this.$message.error('请输入单位')
            } else {
                this.$http.post('/api/user/service/create', qs.stringify({
                    id: this.$route.query.id,
                    demand: this.formItem.demand,
                    unit: this.formItem.unit,
                    category_id: this.formItem.category_id,
                    name: this.formItem.name
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '修改成功'
                            })
                            router.go(-1)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
        },
        getCategories () {
            this.$http.get('/api/user/service/category')
                .then(res => {
                    if (res.code === 0) {
                        this.categories = res.data.listData
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
</style>
